var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creation-item"},[(_vm.iconName)?_c('div',{staticClass:"icon"},[_c('Icon',{attrs:{"name":_vm.iconName}})],1):_vm._e(),_c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.data.title))]),_c('h6',[_vm._v(_vm._s(_vm.formatDate(_vm.data.lastUpdated, '&mon &dd, &year')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }